var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container main",attrs:{"id":"app"}},[_c('navigation-form-component'),_c('main',{class:{'dark': _vm.dark}},[_c('transition',{attrs:{"name":"scale-fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('footer-component',{attrs:{"show-text1":false}}),_c('cookie-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }